/* @flow */
import React, { Component } from 'react'
import { connect } from 'react-redux'

import type { RootState, Design, Customer, CheckedoutPoll } from '../types'

import { selectDesignsWherePollTypeId } from '../stores/designsStore'
import {
  isPoll1D,
  isPoll2D,
  isPollRanking,
  isPollSlider,
} from '../stores/pollsStore'
import { selectCustomers } from '../stores/customersStore'
import { isAdmin } from '../stores/usersStore'

import { selectCurrentUser } from '../stores/currentUser'

import {
  selectCheckedoutPoll,
  updateCheckedoutPoll,
} from '../stores/pollBuilderCheckedoutPoll'

import Condition from './Condition'
import OneAxisPollForm from './PollForm/OneAxisPollForm'
import TwoAxesPollForm from './PollForm/TwoAxesPollForm'
import RankingPollForm from './PollForm/RankingPollForm'
import SliderPollForm from './PollForm/SliderPollForm'
import SnippetModal from './Snippets'

export const MIN_POLL_LABEL_LENGTH: number = 1
export const MAX_POLL_LABEL_LENGTH: number = 75

export const MAX_SLIDER_STEPS_LENGTH: number = 2
export const MAX_SLIDER_VALUE_LENGTH: number = 10

type Props = {
  checkedoutPoll: ?CheckedoutPoll,
  updateCheckedoutPoll: Function,

  designs: Array<Design>,
  customers: Array<Customer>,

  isAdmin: boolean,
}

function isPollTypeEditSupported(poll: CheckedoutPoll): boolean {
  return [isPoll1D, isPoll2D, isPollSlider, isPollRanking]
    .map(typeChecker => typeChecker(poll))
    .reduce((prev, next) => prev || next, false)
}

class CheckedoutPollComponent extends Component<Props> {
  render() {
    const props = this.props

    const maybeCheckedoutPoll: ?CheckedoutPoll = props.checkedoutPoll
    if (maybeCheckedoutPoll == null) {
      throw new Error('props.checkedoutPoll must not be null in PollBuilder')
    }
    const checkedoutPoll: CheckedoutPoll = maybeCheckedoutPoll

    if (!isPollTypeEditSupported(checkedoutPoll)) {
      return (
        <div>
          editing polls of type {checkedoutPoll.kind} is not yet supported
        </div>
      )
    }

    return (
      <div className="w-100 bg-white">
        <SnippetModal />

        <Condition shouldRender={isPoll1D(checkedoutPoll)}>
          <OneAxisPollForm poll={checkedoutPoll} isAdmin={props.isAdmin} />
        </Condition>

        <Condition shouldRender={isPollSlider(checkedoutPoll)}>
          <SliderPollForm poll={checkedoutPoll} isAdmin={props.isAdmin} />
        </Condition>

        <Condition
          shouldRender={isPollRanking(checkedoutPoll)}
          className="w-100"
        >
          <RankingPollForm poll={checkedoutPoll} isAdmin={props.isAdmin} />
        </Condition>

        {/* TODO change this verificarion to someting more scalable  */}
        <Condition
          shouldRender={
            !isPoll1D(checkedoutPoll) &&
            !isPollRanking(checkedoutPoll) &&
            !isPollSlider(checkedoutPoll)
          }
        >
          <TwoAxesPollForm
            poll={checkedoutPoll}
            {...props}
            updatePoll={props.updateCheckedoutPoll}
          />
        </Condition>
      </div>
    )
  }
}

function mapStateToProps(state: RootState) {
  const user = selectCurrentUser(state)
  let checkedoutPoll = selectCheckedoutPoll(state)

  const designs = !checkedoutPoll
    ? []
    : selectDesignsWherePollTypeId(state, checkedoutPoll.kind)

  return {
    checkedoutPoll,
    designs,
    customers: selectCustomers(state),
    isAdmin: user != null && isAdmin(user),
  }
}

const mapDispatchToProps = {
  updateCheckedoutPoll,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CheckedoutPollComponent)



// WEBPACK FOOTER //
// ./src/components/CheckedoutPoll.js